import { render, staticRenderFns } from "./files.vue?vue&type=template&id=3c820d2a&scoped=true"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"
import style0 from "./files.vue?vue&type=style&index=0&id=3c820d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c820d2a",
  null
  
)

export default component.exports